const TypesOfLocationEnum = {
    "CUSTOM_EXAM": "CUSTOM_EXAM",
    "ZIP": "ZIP",
    "PDF": "PDF",
    "SETTINGS" : "SETTINGS",
    "SPLIT_SCREEN": "SPLIT_SCREEN",
    "TESTS": "TESTS",
    "ERROR": "ERROR"
}

export default TypesOfLocationEnum